const alpha_code = localStorage.getItem("alpha_code") || "in";

export const base_url = process.env.REACT_APP_API;

export const category_three_url = "/web/web_category3/";

export const web_inner_subcategories_url = "/web/web_category3/";

// export const web_categories_url = `/${alpha_code}/web/web_categories/`;

export const banner_adv_url = `/${alpha_code}/web/web_ads/`;

export const login_url = `/${alpha_code}/web/login/`;

export const country_url = "/masters/country/";

export const signup_url = `/users-api/alluser/`;

export const Otp_url = "/users-api/otp/";

export const Cart = `/${alpha_code}/tagon_products/cart/`;

export const Reotp_url = "/users-api/resend_users/";

export const helpcenter = "/helpcenter/helpform/";

// export const third_category_api="/in/product_category/category03/"

export const third_category = (categorySecondId) =>
  `/in/product_category/category03/?category_second=${categorySecondId}`;

export const Mens_adv_url = `/${alpha_code}/web/web_ads/`;

export const Wish = `/${alpha_code}/tagon_products/wish/`;

export const seller_url = `/${alpha_code}/seller/`;

export const follow_url = (sellerId) =>
  `/${alpha_code}/seller/${sellerId}/follow_seller/`;

export const Home_banner_url = `/${alpha_code}/ad/homepage_Image_1/`;

export const Produts_Add = `/${alpha_code}/tagon_products/product_add/`;

// export const Produts_Add = `/${alpha_code}/tagon_products/product_add/`;

export const searchGlobal = `/${alpha_code}/tagon_products/product_add/?store=global&search=`;

export const Order_history = `/${alpha_code}/tagon_products/order-history/`;

// export const Woman_Produts_Add = (categoryId = "") =>
//   `/api/tagon_products/product_add/?limit=6${categoryId ? `&third_category=${categoryId}` : ""}`;

export const Compare_add = `/${alpha_code}/tagon_products/compare/`;
export const produts_banner = `/${alpha_code}/ad/Production_banner/`;

export const Brand_url_top = `/${alpha_code}/brand/brands/?brand=hot`; //

export const Brand_url = `/${alpha_code}/brand/brands/?search=`;
// global store versions
export const Brand_url_new_global = `/${alpha_code}/brand/brands/?brand=premium&store=global`;

export const Brand_url_top_global = `/${alpha_code}/brand/brands/?brand=hot&store=global`;

export const forget_password = "/users-api/api/change-password/";

export const Coupan = `/${alpha_code}/coupons/discount/`;

export const Brand_url_new = `/${alpha_code}/brand/brands/?brand=primum`;

export const Address_url = (addressId) =>
  addressId ? `/users-api/address/${addressId}/` : "/users-api/address/";

export const Wallet_url = `/${alpha_code}/wallet/wallet_log`;

export const Wallet_ledger = `/${alpha_code}/wallet/wallet_ledger`;

// export const Filter_url = `/${alpha_code}/tagon_products/filters/?cat_id=125&cat_type=3`;

export const Filter_url = `/${alpha_code}/tagon_products/filters/`;

export const City_url = "/masters/city/";

export const state_url = "/masters/state/";

export const logout_url = `/${alpha_code}/web/logout/`;

export const refresh_token = "/erp_refresh/";

export const helpcenter_form = "/helpcenter/helpform/";

export const helpcenter_number = "/helpcenter/helpnumber/";

export const b2bLedger = `/${alpha_code}/wallet/b2bledger/`;

export const b2bcredit = `/${alpha_code}/wallet/b2bcredit`;

export const point_url = `/${alpha_code}/wallet/tagon_coin`;

export const Order_summary = `/${alpha_code}/tagon_products/order_summary/`;

export const shop_cart = `/${alpha_code}/tagon_products/cart/`;

export const getPromoCodeUrl = (cartId) => {
  return `${alpha_code}/tagon_products/cart/${cartId}/apply_promo_code/`;
};

export const Order_Logs = (orderId) => `/pay/track_order/${orderId}/`;

export const OrderHistoryUrl = (orderId) =>
  `/in/tagon_products/order-history/${orderId}/`;

export const password_reset_api = `/password-reset/`;

export const otp_api = `/password-reset/validate_token/`;

export const confirm_password = `/password-reset/confirm/`;

export const category_one = `/${alpha_code}/web/web_category1/`;

export const category_two = `/${alpha_code}/web/web_category2/`;

export const category_three = `/${alpha_code}/web/web_category3/`;

export const Profile_Mob_Api = `/users-api/mob-otp/`;

export const ChangePassword_profile_page = `/users-api/api/change-password/`;

// export const signup_url = `/users-api/alluser/`;

// "faqtitle": "http://api1-dev.tagonstore.com/helpcenter/faqtitle/",
// "faqcontent": "http://api1-dev.tagonstore.com/helpcenter/faqcontent/",

export const faqtitle = `/helpcenter/faqtitle/`;
export const faqcontent = `/helpcenter/faqcontent/`;
export const LegalTitle = `/legal-api/legaltitle/`;
export const LegalContent = `/legal-api/legalcontent/`;
export const pls_privacy_policy_api = `/delivery-api/privacy/`;
export const pls_terms_api = `/delivery-api/termsandcondn/`;
export const track = `pay/track_order/`;

export const orderhistory_api = `/${alpha_code}/tagon_products/order-history/`;

export const get_bank_otp_api = "/bank/user_otp";

export const verify_bank_otp_api = `/bank/otp_verify`;

export const upi_api = "/bank/upi-details/";

export const bank_details_api = "/bank/bank-details/";
// This function will return a dynamic URL based on the orderId
export const delete_account_otp_url = `/${alpha_code}/web/otp/`;

export const delete_account_url = `/${alpha_code}/web/del-acc`;

export const delete_account_resend_otp_url = `/${alpha_code}/web/resend_otp/`;

export const check_delivery = `/${alpha_code}/tagon_products/check_delivery/`;

export const new_arrival_api = `/${alpha_code}/tagon_products/new/`;

export const limited_time_deal_api = `/${alpha_code}/tagon_products/timely_deals/`;

export const pls_delete_account_api = "/delivery-api/otp/"
